import {configureStore, combineReducers} from '@reduxjs/toolkit';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {createStateSyncMiddleware} from 'redux-state-sync';

import reducers from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['defaultFilters'],
};
const stateSyncConfig = {
  whitelist: ['defaultFilters'],
};
const rootReducers = combineReducers(reducers);
const persistedReducers = persistReducer(persistConfig, rootReducers);
const store = configureStore({reducer: persistedReducers, middleware: [createStateSyncMiddleware(stateSyncConfig)]});
const persistor = persistStore(store);
export {store, persistor};
